module.exports = __webpack_public_path__ + "img/ax.fdfe7fec.svg";